export const Diamond = ({ className = "" }) => (
  <span className={`inline-block h-2.5 w-2.5 rotate-45 bg-bordeaux ${className}`} aria-hidden="true" />
);

export const Ornament = ({ light = false }) => (
  <div className="flex items-center justify-center gap-5" data-testid="ornament-divider" aria-hidden="true">
    <span className={`h-px w-16 md:w-24 ${light ? "bg-ivory/60" : "bg-bordeaux"}`} />
    <span className={`h-2.5 w-2.5 rotate-45 ${light ? "bg-ivory" : "bg-bordeaux"}`} />
    <span className={`h-px w-16 md:w-24 ${light ? "bg-ivory/60" : "bg-bordeaux"}`} />
  </div>
);
